const PERMISSION_KEY= "crm:popup_info";
const PAGE_URL = {
    POPUP_INFO_PAGE: "/admin/crm/popup-info"
}

export {PERMISSION_KEY, PAGE_URL}

